import { jsx as _jsx } from "react/jsx-runtime";
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { Editor_DemoPatient } from '../Editor_DemoPatient/Editor_DemoPatient.js';
import { tsEpicDemoPatientValidator } from '@app/org-shared';
export class Editor_EpicDemoPatient extends TS_EditableItemComponent {
    render() {
        const { mode, onDelete, index } = this.props;
        const editable = this.state.editable;
        return _jsx(Editor_DemoPatient, { index: index, mode: mode, onDelete: onDelete, validator: tsEpicDemoPatientValidator, editable: editable, patientProps: [
                { name: 'label', label: 'Label' },
                { name: 'patientId', label: 'Patient Id' },
            ] });
    }
}
//# sourceMappingURL=Editor_EpicDemoPatient.js.map